module.exports = __webpack_public_path__ + "img/858046db94b8616d691676712d7d7dde.png";